import { render, staticRenderFns } from "./form.vue?vue&type=template&id=765bde4e&scoped=true&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&id=765bde4e&prod&scoped=true&lang=css&"
import style1 from "./form.vue?vue&type=style&index=1&id=765bde4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765bde4e",
  null
  
)

export default component.exports